export default __webpack_public_path__ + "static/media/logo_light.8dbb33f5.svg";